module.exports = __webpack_public_path__ + "media/audios/kid/lesson_4/audio_tpc4-c0b5d25f604a2c7d8247547529f99772.m4a";